import React, { useState } from "react";

const RCSearch = () => {
  const [rcNumber, setRcNumber] = useState("");
  const [data, setData] = useState(null);
  const [pdfUrl, setPdfUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    setData(null);

    try {
      const res = await fetch("https://vahanapi.site/api/rcfull.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          rc_number: rcNumber
        })
      });

      const result = await res.json();

      if(result.status){
        setData(result.data);
        setPdfUrl(result.pdf_file);
      } else {
        alert(result.message);
      }

    } catch (err) {
      console.error(err);
      alert("Server Error");
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>RC Search</h2>

      <input
        value={rcNumber}
        onChange={(e) => setRcNumber(e.target.value.toUpperCase())}
        placeholder="Enter RC Number"
      />

      <button onClick={handleSearch}>Search</button>

      {loading && <p>Loading...</p>}

      {/* TABLE */}
      {data && (
        <>
          <table border="1" cellPadding="10" style={{ marginTop: "20px" }}>
            <tbody>
              {Object.entries(data).map(([key, value]) => (
                <tr key={key}>
                  <td><b>{key}</b></td>
                  <td>{value?.toString()}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* DOWNLOAD BUTTON */}
          <a href={pdfUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ marginTop: "20px" }}>
              Download PDF
            </button>
          </a>
        </>
      )}
    </div>
  );
};

export default RCSearch;